// Enemy type definitions and configurations
export interface EnemyConfig {
  type: string;
  name: string;
  hp: number;
  speed: number;
  score: number;
  size: number;
  color: string;
}

export const ENEMY_TYPES: Record<string, EnemyConfig> = {
  HUNGER_BUG: {
    type: 'hunger_bug',
    name: 'Hunger Bug',
    hp: 1,
    speed: 2.5,
    score: 50,
    size: 72,
    color: '#ffaa00',
  },
  HOMELESSNESS_SHADOW: {
    type: 'shadow',
    name: 'Homelessness Shadow',
    hp: 2,
    speed: 1.5,
    score: 100,
    size: 84,
    color: '#666666',
  },
  GREED_GREMLIN: {
    type: 'greed',
    name: 'Greed Gremlin',
    hp: 3,
    speed: 3,
    score: 150,
    size: 78,
    color: '#00ff00',
  },
};

// Enemy movement patterns
export enum MovementPattern {
  ZIGZAG = 'zigzag',
  DRIFT = 'drift',
  DIVE = 'dive',
  HORIZONTAL = 'horizontal',
  SINE_WAVE = 'sine_wave',
  CIRCLE = 'circle',
}

// Assign movement patterns to enemy types
export const ENEMY_PATTERNS: Record<string, MovementPattern> = {
  hunger_bug: MovementPattern.ZIGZAG,
  shadow: MovementPattern.DRIFT,
  greed: MovementPattern.DIVE,
};
